<template>
  <div class="container">
    <div class="row">
      <div class="text--base chart__white">
        <PackedCirclesInvestment v-if="packedCirclesTitle" :content="packedCirclesTitle" />
      </div>
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import PackedCirclesInvestment from '@/components/content/chapter2/PackedCirclesInvestment.vue';

export default {
  name: 'App5CircleTreemap',
  components: {
    PackedCirclesInvestment,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    packedCirclesTitle() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'packed-circles-platforms') : {};
    },
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-02.json`);
  },
};
</script>

<style scoped lang="scss">
  .chart__white {
    background-color: #ffffff;
    padding: 60px 0;
  }
</style>